import React, { Component } from "react";

export default class FormActions extends Component {
  render() {
    return (
      <div className="form-actions">
        <div className="secondary">{this.props.left}</div>
        <div className="form-primary">{this.props.right}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormActions/FormActions.js